import validate from "/app/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.22.0_jiti@2.4.2__io_6sad5g4f4rpsra4tj2klfsuxym/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45config_45global from "/app/middleware/01.config.global.ts";
import _01_45reload_45ot_45banner_45global from "/app/middleware/01.reloadOTBanner.global.ts";
import _01_45user_45global from "/app/middleware/01.user.global.ts";
import _02_45route_45track_45global from "/app/middleware/02.route-track.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.22.0_jiti@2.4.2__io_6sad5g4f4rpsra4tj2klfsuxym/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45config_45global,
  _01_45reload_45ot_45banner_45global,
  _01_45user_45global,
  _02_45route_45track_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "0-redirects": () => import("/app/node_modules/.pnpm/@wmt+nuxt-base-layer@3.0.0_@opentelemetry+api@1.9.0_@opentelemetry+context-async-hooks@1.30.1_sp2vknwfyobhk3rie245ancntq/node_modules/@wmt/nuxt-base-layer/middleware/0-redirects.ts")
}